enum UploadProgress {
  idle,
  uploading,
  completed
}

export default UploadProgress;
